import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";
import { cn } from "../utils/cn";

export type ProgressColor = "default" | "success" | "warning" | "destructive";

const colorMap: Record<ProgressColor, string> = {
    default: "bg-secondary",
    success: "bg-success",
    warning: "bg-warning",
    destructive: "bg-destructive",
};

export interface ProgressProps extends React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> {
    color?: ProgressColor;
}

const Progress = React.forwardRef<React.ElementRef<typeof ProgressPrimitive.Root>, ProgressProps>(
    ({ className, value, color = "default", ...props }, ref) => (
        <ProgressPrimitive.Root
            ref={ref}
            className={cn("bg-muted relative h-2 w-full overflow-hidden rounded-full", className)}
            {...props}
        >
            <ProgressPrimitive.Indicator
                className={cn("h-full w-full flex-1 rounded-full transition-all", colorMap[color])}
                style={{ transform: `translateX(-${100 - (value ?? 0)}%)` }}
            />
        </ProgressPrimitive.Root>
    ),
);
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
